function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  strokeWidth: 8,
  strokeMiterlimit: 10,
  d: "M96.22,12.524 C91.047,6.964,83.799,3.801,76.205,3.79c-7.601,0.009-14.854,3.17-20.035,8.731l-1.767,1.866l-1.767-1.866 c-5.387-5.799-12.703-8.733-20.038-8.733c-6.662,0-13.34,2.42-18.606,7.313c-0.49,0.456-0.964,0.929-1.419,1.419 c-10.904,11.762-10.904,29.938,0,41.701l39.234,41.375c0.703,0.742,1.648,1.115,2.596,1.115c0.882,0,1.766-0.324,2.457-0.979 c0.048-0.043,0.094-0.09,0.138-0.137L96.22,54.222C107.123,42.46,107.123,24.284,96.22,12.524z"
});

var SvgHeart = function SvgHeart(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    width: 35,
    height: 35,
    viewBox: "0.063 -0.5 108.667 101.5",
    enableBackground: "new 0.063 -0.5 108.667 101.5",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHeart, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/heart.17605733.svg";
export { ForwardRef as ReactComponent };